import Video from './__constants/video';
import pageScroll from './__modules/pageScroll';
import sectionScroll from './__modules/sectionScroll';
import headerColor from './__modules/headerColor';
import showMenu from './__modules/showMenu';
import customTabs from './__modules/customTabs';
import customTabsWithSlider from './__modules/customTabsWithSlider';
import teamSlider from './__modules/teamSlider';
import animatedChart from './__modules/animatedChart';
import anchorScroll from './__modules/anchorScroll';

jQuery(document).ready(() => {
	headerColor();
	showMenu();
	customTabs();
	customTabsWithSlider();
	teamSlider();
	sectionScroll();
	pageScroll();
	animatedChart();
	anchorScroll();
});

window.addEventListener('load', () => {
	Video();
});

window.addEventListener('resize', () => {

});

jQuery(window).on('resize scroll', () => {

});
